import { ApplicationRoutes } from '../../../app-routes-names'

export const LocationsRoutes = {
  status: 'status'
}

const { locations } = ApplicationRoutes

export const LocationsPaths = {
  status: `/${locations}/${LocationsRoutes.status}`
}
